import React from 'react';
import albanian from '../constants/langs/al.json';
import english from '../constants/langs/en.json';

type LangMap = Record<string, string>;

const NEW_KEY = 'mika.locale';
const LEGACY_KEY = 'mikaSelectedLanguage';

function getActiveLocale(): 'sq' | 'en' {
    try {
        const fromNew = localStorage.getItem(NEW_KEY);
        if (fromNew === 'sq' || fromNew === 'en') return fromNew;
    } catch { /* ignore */ }

    try {
        const legacy = localStorage.getItem(LEGACY_KEY);
        if (legacy) {
            const parsed = JSON.parse(legacy);
            if (parsed?.value === 1) return 'sq';
            if (parsed?.value === 2) return 'en';
        }
    } catch { /* ignore */ }

    return 'sq';
}

function resolve(id: string, defaultMessage: string): string {
    const locale = getActiveLocale();
    const table: LangMap = (locale === 'sq' ? albanian : english) as unknown as LangMap;
    return table[id] || defaultMessage;
}

// `values` fills {placeholder} slots in the resolved string. Optional, so every
// existing caller is unaffected. Placeholders (not concatenation) keep the word
// order translatable — the reason may sit mid-sentence in another language.
export function translatedText(
    { id, defaultMessage, values }: { id: string; defaultMessage: string; values?: Record<string, string | number> }
): string {
    let out = resolve(id, defaultMessage);
    if (values) {
        for (const [key, value] of Object.entries(values)) {
            out = out.split(`{${key}}`).join(String(value));
        }
    }
    return out;
}

const TranslatedText = ({ id, defaultMessage }: { id: string; defaultMessage: string }) => {
    return <>{resolve(id, defaultMessage)}</>;
};

export default TranslatedText;
